import React, { createContext, useState, useContext, useEffect } from 'react';

const ComponentContext = createContext();

export const ComponentProvider = ({ children }) => {
  const [activeComponent, setActiveComponent] = useState('home');
  const [currentComponent, setCurrentComponent] = useState(null);

  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('/student/')) {
      const pathParts = path.split('/');
      const componentName = pathParts[pathParts.length - 1];
      if (componentName !== 'home') {
        setActiveComponent(componentName);
      }
    }
  }, []);

  const switchComponent = (componentName, component) => {
    setActiveComponent(componentName);
    setCurrentComponent(component);
    
    if (componentName !== 'home') {
      window.history.pushState(null, '', `/student/${componentName}`);
    } else {
      window.history.pushState(null, '', `/student/home`);
    }
  };

  return (
    <ComponentContext.Provider value={{ activeComponent, currentComponent, switchComponent }}>
      {children}
    </ComponentContext.Provider>
  );
};

export const useComponentContext = () => useContext(ComponentContext);
